import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BlogSingleMain from "./blog-details";
import BreadCrumb from "../../common/breadcrumb";
import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import FooterTwo from "../../../layout/footers/footer-two";
import { getBlogs } from "../../../utils/cms.utils";

const BlogDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [singleData, setSingleData] = useState(null);
    const [loading, setLoading] = useState(true);

    /* =========================
       GET BLOG FROM CMS CACHE
    ========================== */
    useEffect(() => {
        try {
            const blogs = getBlogs();
            const items = Array.isArray(blogs) ? blogs : [];

            const found = items.find(
                (blog) => String(blog.id) === String(id)
            );

            if (!found) {
                navigate("/404-error", { replace: true });
                return;
            }

            setSingleData(found);
        } catch (err) {
            console.error("Blog detail error:", err);
            navigate("/404-error", { replace: true });
        } finally {
            setLoading(false);
        }
    }, [id, navigate]);

    if (loading || !singleData) return null;

    const breadcrumbTitle =
        singleData.title
            ?.split(" ")
            .slice(0, 3)
            .join(" ") + "...";

    return (
        <>
            <SEO pageTitle={singleData.title} />
            <HeaderTwo />

            <BreadCrumb
                title={breadcrumbTitle}
                items={[
                    { label: "Blog & News", to: "/blog" },
                    { label: breadcrumbTitle },
                ]}
            />

            <BlogSingleMain singleData={singleData} />

            <FooterTwo />
        </>
    );
};

export default BlogDetails;
